import { RedirectsContainer } from '@/modules/Redirects/containers/RedirectsContainer';

export const Redirects = (): JSX.Element => <RedirectsContainer />;

export default Redirects;
